import React from 'react';
import DatePickerFooterView from './DatePickerFooter.view';

type Props = {
  time?: string;
  onUpdate: (time: string) => void;
};

const DatePickerFooter = (props: React.PropsWithChildren<Props>): JSX.Element => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (value) {
      props.onUpdate(value);
    }
  };

  return <DatePickerFooterView time={props.time} onChange={onChange}></DatePickerFooterView>;
};

DatePickerFooter.displayName = 'DatePickerFooter';

export default DatePickerFooter;
